import React, { memo } from 'react'
import {
  PageContent,
  PageHeader as PageHeaderV3,
  PageLoadingIndicator,
} from 'components/Layouts/V3'
import { isGuest } from 'services/user'
import Condition from 'components/Condition'
import ConditionSwitch from 'components/ConditionSwitch'
import PageHeader from 'components/PageHeader'
import PageHeaderTitle from 'components/PageHeaderTitle'
import PagePlaceholder from 'components/PagePlaceholder'
import { graphql, useLazyLoadQuery } from 'react-relay'
import { PageBundlePlaceholder_GetCurrentUserQuery } from '__generated__/PageBundlePlaceholder_GetCurrentUserQuery.graphql'
import { Nullable } from 'types'

interface IPageBundlePlaceholderProps {
  error?: Nullable<string>
}

function PageBundlePlaceholder({ error }: IPageBundlePlaceholderProps) {
  const user = useLazyLoadQuery<PageBundlePlaceholder_GetCurrentUserQuery>(graphql`
    query PageBundlePlaceholder_GetCurrentUserQuery {
      currentUser {
        ...user_isGuest
      }
    }
  `, {}, {
    fetchPolicy: 'store-and-network',
  })
  const enableSidebarLayout = !isGuest(user?.currentUser)

  if (enableSidebarLayout) {
    return (
      <ConditionSwitch>
        <Condition condition={Boolean(error)}>
          <PageContent>
            <PagePlaceholder
              title="Error"
              subtitle={error}
            />
          </PageContent>
        </Condition>
        <Condition condition>
          <PageHeaderV3 data-cy="page-bundle-placeholder">
            <PageLoadingIndicator>Loading Page...</PageLoadingIndicator>
          </PageHeaderV3>
        </Condition>
      </ConditionSwitch>
    )
  }

  return (
    <PageHeader autoCompact autoAlternative data-cy="page-bundle-placeholder">
      {!error && (
        <PageHeaderTitle>
          ...
        </PageHeaderTitle>
      )}
      {error && (
        <PagePlaceholder
          title="Error"
          subtitle={error}
        />
      )}
    </PageHeader>
  )
}

export default memo(PageBundlePlaceholder)
